import { Theme } from '@mui/material/styles';

/**
 * PaperProps for Dialog components to support dark mode.
 * Cascades styles to all child inputs, labels, and buttons.
 * Apply as: <Dialog PaperProps={dialogPaperProps} ...>
 */
export const dialogPaperProps = {
  sx: (theme: Theme) => ({
    backgroundColor: theme.custom?.background1,
    color: theme.custom?.text,
    '& .MuiDialogTitle-root': {
      color: theme.custom?.text,
    },
    '& .MuiDialogContentText-root': {
      color: theme.custom?.textLight,
    },
    '& .MuiInputBase-root': {
      color: theme.custom?.text,
      backgroundColor: theme.custom?.background2,
    },
    '& .MuiInputLabel-root': {
      color: theme.custom?.textLight,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.custom?.stroke,
    },
    '& .MuiDialogActions-root .MuiButton-text': {
      color: theme.custom?.textLight,
    },
  }),
} as const;
